const timeFormat = new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit" });
const dayFormat = new Intl.DateTimeFormat(undefined, { month: "short", day: "numeric" });
const fullFormat = new Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", second: "2-digit" });

export function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

/** "3:04 PM" today, "Sep 21" before today. */
export function shortTime(iso: string, now: Date): string {
  const date = new Date(iso);
  return isSameDay(date, now) ? timeFormat.format(date) : dayFormat.format(date);
}

export function fullTime(iso: string): string {
  return fullFormat.format(new Date(iso));
}

export function percent(value: number): string {
  return `${Math.round(value * 100)}`;
}

export function hourLabel(hour: number): string {
  return `${String(hour).padStart(2, "0")}:00`;
}
